import src from "IMAGE";
export default { src, width: 121, height: 121, blurWidth: 0, blurHeight: 0};
